import { jsx as _jsx } from "react/jsx-runtime";
import { Close } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { memo } from "react";
export const SearchCommandClearButton = /*#__PURE__*/ memo((param)=>{
    let { onClick } = param;
    return /*#__PURE__*/ _jsx(IconButton, {
        appearance: "ghost",
        className: "absolute right-2 top-2",
        color: "grey",
        icon: Close,
        label: "Close",
        size: "small",
        onClick: onClick
    });
});
SearchCommandClearButton.displayName = "SearchCommandClearButton";
